import type { MonthlyStatementLayout } from '../types';

export const FALLBACK_MONTHLY_STATEMENT_LAYOUT: MonthlyStatementLayout = {
  uid: 'fallback',
  locale: 'en-us',
  title: 'Monthly Statement (fallback)',
  layout: [
    { hero: { logo: { url: '' }, title: '', hero_image: { url: '/assets/header-image.png' } } },
    {
      greeting: {
        subtitle_fallback: 'Hey {name}',
        greeting_template: "Here's your Inner Circle snapshot for October",
        name_fallback: 'Guest',
      },
    },
    { visit_summary: { stats: { label: 'Visit Balance', data_source: 'currentVisitBalance', empty_label: '0' } } },
    {
      upsell_banner: {
        title: 'You have enough Visits to cash in for a reward!',
        body: "Head to the Circle K app to see what's waiting. Here's a peek at some rewards we think you might like.",
        unmet_requirements_title: 'Keep visiting to get close to your next reward!',
        unmet_requirements_body: 'Once you earn 5 Visits, you can cash them in for a reward, like one of these:',
        promo_banner: {
          title: 'Want something BIGGER?',
          body: 'Save your Visits and keep building toward a bigger reward - like up to $1 off/gal!',
          icon: { url: '/assets/coin.png' },
        },
        link: { title: '', href: '' },
      },
    },
    {
      member_deals: {
        title: 'Members-only deals are waiting',
        subtitle: 'No Visits required to save big on these faves.',
        link: { title: '', href: '' },
        disclaimers: '',
      },
    },
    {
      footer: {
        logo: { url: '/assets/circlek-logo.png' },
        follow_label: 'Follow us:',
        social_links: [
          { link: { title: '', href: '' }, icon: { url: '/assets/facebook-logo.png' }, displayName: 'Facebook' },
          { link: { title: '', href: '' }, icon: { url: '/assets/x-logo.png' }, displayName: 'X (Twitter)' },
          { link: { title: '', href: '' }, icon: { url: '/assets/instagram-logo.png' }, displayName: 'Instagram' },
        ],
        legal_copy: '',
        copyright: '',
      },
    },
  ],
};
